const translations = [
  { "en-US": "Contacts" },
  { "en-US": "Client Flow" },
  { "en-US": "Marketing" },
  { "en-US": "Campaigns" },
  { "en-US": "Email Builder" },
  { "en-US": "SMS Templates" },
  { "en-US": "Scheduler" },
  { "en-US": "Settings" },
  { "en-US": "Conversations" },
  { "en-US": "Landing Page" },
  { "en-US": "Forms and Ads" },
  { "en-US": "Chat Widget" },
  { "en-US": "My Practice" },
  { "en-US": "Dashboard" },
  { "en-US": "Practice Information" },
  { "en-US": "My Team" },
  { "en-US": "Website Integration" },
  { "en-US": "Loyalty" },
  { "en-US": "Loyalty" },
  { "en-US": "Users" },
  { "en-US": "Documents" },
  { "en-US": "Reporting" },
  { "en-US": "Transactions" },
  { "en-US": "Marketing" },
  { "en-US": "Loyalty" },
  { "en-US": "Rooms and Catalog" },
  { "en-US": "Virtual Consult" },
  { "en-US": "Employee Calendar" },
  { "en-US": "Treatments" },
  { "en-US": "Memberships" },
  { "en-US": "Summary" },
  { "en-US": "Services" },
  { "en-US": "Charting" },
  { "en-US": "Consent Forms" },
  { "en-US": "Transaction Reporting" },
  { "en-US": "Specials" },
  { "en-US": "Gift Cards" },
  { "en-US": "Packages" },
  { "en-US": "Webhooks" },
  { "en-US": "Inbox" },
  { "en-US": "Call Report" },
  { "en-US": "Ads" },
  { "en-US": "Inbox (new)" },
];

export default translations;
